// Module
var code = "<div v-if=\"show\" class=\"loading-spinner\"> <div id=\"dots5\"> <span/> <span/> <span/> <span/> </div> </div> ";
// Exports
export default code;